import { FC, useEffect, useState } from 'react';

import { RaaSelect } from 'raa-react';

import { DrawerSection } from 'components/drawerSections/DrawerSections';
import RaaInputField from 'components/fieldComponents/raaInputField/RaaInputField';
import RaaTextAreaField from 'components/fieldComponents/raaTextAreaField/RaaTextAreaField';
import { SammansattFormValues } from 'components/utkast/utkastRegistration/UtkastFormSchema';

import { BebyggelseobjektDomaner, BebyggelseobjektUtkast, ForvaltningsorganisationTyp, Skyddstyp } from 'models';

import { BebyggelseobjektgruppEnum, SkyddsklassningstypEnum } from 'enums';

import { useFormikContext } from 'formik';

interface SkyddSectionProps {
  utkastData: BebyggelseobjektUtkast;
  domaner: BebyggelseobjektDomaner;
}

const SkyddSection: FC<SkyddSectionProps> = ({ utkastData, domaner }) => {
  const [selectedSkyddsTyp, setSelectedSkyddsTyp] = useState<Skyddstyp | undefined>(undefined);
  const [selectedForvaltare, setSelectedForvaltare] = useState<ForvaltningsorganisationTyp | undefined>(undefined);
  const { setFieldValue } = useFormikContext<SammansattFormValues>();
  useEffect(() => {
    if (utkastData && domaner) {
      if (utkastData) {
        const skyddsTyp = domaner.skyddstyper.find((s) => s.skyddstyp === utkastData.skydd.skyddstyp);
        setSelectedSkyddsTyp(skyddsTyp);
        const forvalt = domaner.forvaltningsorganisationer.find(
          (f) => f.forvaltningsorganisation_id === utkastData.skydd.forvaltningsorganisation_id
        );
        setSelectedForvaltare(forvalt);
      }
    }
  }, [utkastData, domaner]);

  return (
    <>
      <DrawerSection>
        <fieldset>
          {selectedSkyddsTyp && (
            <>
              <legend className="tw-heading-md tw-mb-4">{selectedSkyddsTyp.namn}</legend>
              <p>{selectedSkyddsTyp.forklaring}</p>

              <table className="tw-mt-2 tw-shrink tw-grow tw-basis-auto">
                <tbody className="tw-align-top [&>tr>th]:tw-pr-2 [&>tr>th]:tw-text-left">
                  {utkastData.skydd.kyrkligtkulturminneskyddstyp_namn && (
                    <tr>
                      <th>Typ</th>
                      <td>{utkastData.skydd.kyrkligtkulturminneskyddstyp_namn}</td>
                    </tr>
                  )}

                  <tr>
                    <th className="tw-whitespace-nowrap">Ansvarig myndighet</th>
                    <td>{selectedSkyddsTyp.ansvarig_myndighet}</td>
                  </tr>
                </tbody>
              </table>
            </>
          )}

          {utkastData.bebyggelseobjektgrupp === BebyggelseobjektgruppEnum.SAMMANSATT &&
            (utkastData.aktivitetref.aktivitetssubtyp === SkyddsklassningstypEnum.BESLUT_OM_STATLIGT_BYGGNADSMINNE ||
              utkastData.aktivitetref.aktivitetssubtyp ===
                SkyddsklassningstypEnum.REVIDERING_AV_STATLIGT_BYGGNADSMINNE) && (
              <div className="tw-mb-4">
                <label className="raa-label tw-mt-4" htmlFor="forvaltare">
                  <span className="tw-pr-2">Förvaltare*</span>
                </label>

                <RaaSelect
                  inputElementId="forvaltare"
                  domain={domaner.forvaltningsorganisationer}
                  displayAttr={'forvaltningsorganisationsnamn'}
                  onSelect={(forvaltare: ForvaltningsorganisationTyp) => {
                    void setFieldValue('skydd.forvaltningsorganisation_id', forvaltare.forvaltningsorganisation_id);
                  }}
                  value={selectedForvaltare}
                />
              </div>
            )}

          <RaaTextAreaField label="Motivering" classString="raa-textarea tw-h-48 tw-mb-4" name="skydd.motivering" />

          {(utkastData.bebyggelseobjektgrupp === BebyggelseobjektgruppEnum.ENSKILT_BEBYGGELSEOBJEKT ||
            utkastData.bebyggelseobjektgrupp === BebyggelseobjektgruppEnum.OMRADE) && (
            <>
              <RaaTextAreaField label="Karaktärsdrag" name="karaktarsdrag" />

              <RaaInputField
                label="Lokal klassning"
                type="text"
                classString="raa-input tw-w-[33%]"
                name="lokal_klassificering"
                shouldValidateForm={true}
              />
            </>
          )}
        </fieldset>
      </DrawerSection>
    </>
  );
};

export default SkyddSection;
